export const selectAllMessagesCommand = "aab";
export default {selectAllMessagesCommand};